import {
  Avatar,
  Button,
  Checkbox,
  Drawer,
  Input,
  List,
  Pagination,
  Space,
  Grid,
  Typography
} from "antd";
const { Text } = Typography;
import React, { useEffect, useState } from "react";
import { ROLES } from "../../Config/helpers/constants";
import { error, success } from "../../common/Alerts/Message";
import { GetAllSearchResults } from "../../Config/API/search";
import TopBar from "../SearchPage/TopBar/TopBar";
import { BiMoney } from "react-icons/bi";
import { KEYS } from "../../Config/Keys";
import { TransferTokensToOtherWallet } from "../../Config/API/Wallets";
import { GiCancel } from "react-icons/gi";
import Beneficiary from "./Beneficiary";

const { useBreakpoint } = Grid;
import "../../styles/Wallet/Transfer.css";

function TransferTokens({
  open,
  setOpen,
  wallet,
  getWallet,
  getUserTransactionHistory,
  userType,
  userId
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [type, setType] = useState(ROLES.player);
  const [data, setData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [amount, setAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [addBeneficiary, setAddBeneficiary] = useState(false);
  const [transferLoading, setTransferLoading] = useState(false);
  const [showBeneficiary, setShowBeneficiary] = useState(true);

  const screens = useBreakpoint();
  const size = screens.xs ? "middle" : "large";

  //   pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 15;

  const getSearchData = async (page) => {
    try {
      if (searchTerm !== "" || searchTerm !== null) {
        setLoading(true);
        const newOffset = (page - 1) * limit;

        const response = await GetAllSearchResults(
          { text: searchTerm, searchFor: type },
          newOffset,
          limit
        );
        const data = await response.json();
        if (data?.type === "failure") {
          error(data.result);
        } else if (data?.type === "success") {
          // remove current user from data if exists
          const filteredData =
            data?.searchData?.length > 0
              ? data?.searchData?.filter((users) => users?._id !== userId)
              : [];
          setData(filteredData);
          setTotalPages(Math.ceil(data?.totalCount / limit));
          setCurrentPage(page);
        }
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      error(e.message);
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  const handleTransfer = async () => {
    setTransferLoading(true);
    if (amount > wallet?.balance) {
      error("Insufficient funds");
      setTransferLoading(false);
    } else if (amount > 0 && selectedUser?.walletId) {
      const response = await TransferTokensToOtherWallet(
        selectedUser?.walletId,
        amount,
        userType,
        addBeneficiary,
        userId
      );

      const data = await response.json();

      if (data?.type === "success") {
        success("Transaction initiated Successfully");
        // get latest transactions again
        getWallet();
        getUserTransactionHistory();
        setAddBeneficiary(false);
        setTransferLoading(false);
        setOpen(false);
      } else {
        error(data?.result?.message || data?.result?.error || data?.result);
        setTransferLoading(false);
      }
    }
  };

  const goToPage = (pageNumber) => {
    getSearchData(pageNumber);
  };

  useEffect(() => {
    getSearchData(1);
  }, [type]);

  return (
    <>
      <Drawer
        placement="right"
        maskClosable={false}
        closable={true}
        onClose={() => setOpen(false)}
        open={open}
        width="100%">
        <h2 style={{ fontWeight: "600", marginBottom: 0 }}>Transfer Token</h2>
        <div className="wallet-container">
          <img src="/images/icons/Group.png" alt="wallet" />
          <div>
            <p>Your Balance</p>
            <p style={{ fontSize: "20px" }}> ${wallet?.balance} </p>
          </div>
        </div>

        <div
          className="wallet-btns"
          style={{ display: "flex", justifyContent: "", columnGap: "1rem" }}>
          <Button
            className=""
            type={showBeneficiary ? "primary" : "default"}
            shape="round"
            size="medium"
            onClick={() => setShowBeneficiary(true)}>
            Beneficiary
          </Button>
          <Button
            className=""
            type={!showBeneficiary ? "primary" : "default"}
            shape="round"
            size="medium"
            onClick={() => setShowBeneficiary(false)}>
            New
          </Button>
        </div>
        {!showBeneficiary && (
          <Input.Search
            className="custom-search"
            placeholder="Search..."
            size={size}
            enterButton="Search"
            value={searchTerm}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ margin: "1rem 0" }}
            onSearch={getSearchData}
          />
        )}
        {showBeneficiary ? null : <TopBar setactive={setType} active={type} forWallet={true} />}

        {!selectedUser && !showBeneficiary && (
          <>
            <List
              loading={loading}
              dataSource={data}
              renderItem={(user) => (
                <List.Item
                  onClick={
                    user?.walletId
                      ? () => setSelectedUser(user)
                      : () => error("Error selecting this user")
                  }
                  style={{
                    cursor: "pointer",
                    backgroundColor: user === selectedUser ? "#f0f0f0" : "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                  }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* Avatar at the start */}
                    <Avatar src={user?.profilepic ? KEYS.API + `/${user?.profilepic}` : null} />
                    {/* User name */}
                    <span style={{ marginLeft: "1rem", color: "#1890FF", fontWeight: "600" }}>
                      {user.name}{" "}
                      {user?.username && (
                        <span style={{ fontSize: "12px" }}>( {user?.username} )</span>
                      )}{" "}
                    </span>
                  </div>
                  {/* Icon at the end */}
                  {user?.walletId && <BiMoney />}
                </List.Item>
              )}
              style={{ marginBottom: "1rem", maxWidth: "400px", overflowX: "auto" }} // Set max width and enable horizontal scroll
            />
            <Pagination
              current={currentPage}
              total={totalPages * limit}
              pageSize={limit}
              showSizeChanger={false}
              onChange={goToPage}
            />
          </>
        )}
        {showBeneficiary && !selectedUser && (
          <Beneficiary beneficiaries={wallet?.beneficiary} setSelectedUser={setSelectedUser} />
        )}
        {selectedUser && (
          <div className="mt-2 mb-2">
            <Text type="success" strong>
              Selected User: <GiCancel onClick={() => setSelectedUser(null)} />
            </Text>{" "}
            <div className="mt-2 mb-2">
              <Avatar
                size={30}
                src={selectedUser?.profilepic ? KEYS.API + `/${selectedUser?.profilepic}` : null}
              />
              <span style={{ color: "#1890FF", marginLeft: "8px", fontWeight: "600" }}>
                {selectedUser?.name}
                {selectedUser?.username && (
                  <span style={{ fontSize: "12px" }}>( {selectedUser?.username} )</span>
                )}{" "}
              </span>
            </div>
          </div>
        )}
        {selectedUser && (
          <Space>
            <Input
              className="custom-amount-input mt-2"
              placeholder="Amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              style={{ marginBottom: "1rem" }}
            />
            {!selectedUser?.isBeneficiary && (
              <Checkbox
                type="checkbox"
                name="addBeneficiary"
                value={addBeneficiary}
                checked={addBeneficiary}
                onChange={(e) => setAddBeneficiary(e?.target?.checked)}>
                Add as Beneficiary
              </Checkbox>
            )}
          </Space>
        )}
        <br />

        <Button
          loading={transferLoading}
          type="primary"
          disabled={amount === 0 || !amount || transferLoading || !selectedUser}
          style={
            amount === 0 || !amount || transferLoading || !selectedUser
              ? {}
              : { backgroundColor: "#02C171", color: "#fff" }
          }
          onClick={handleTransfer}>
          Transfer
        </Button>
      </Drawer>
    </>
  );
}

export default TransferTokens;
